import type { HttpClient } from '../http/HttpClient'
import type { UsageEvent, UsageEventRepository } from '@/domain/usage/UsageEvent'

export class HttpUsageEventRepository implements UsageEventRepository {
  constructor(private readonly http: HttpClient) {}

  async record(events: UsageEvent[]): Promise<void> {
    if (events.length === 0) return
    const body = events.map((event) => ({ event_id: crypto.randomUUID(), event_type: event.type, context: event.context }))
    await this.http.url('usage-events').body({ events: body }).post()
  }
}
